
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"111","viewBox":"0 0 80 111","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.06 97.53s3.49-13.066 22.677-13.066c19.186 0 22.71 13.538 22.71 13.538","fill":"#F9BEF9"}}),_c('path',{attrs:{"d":"M68.466 50.315H4.613v66.374h63.853V50.315z","fill":"#FED766","stroke":"#000","stroke-width":"2","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M4.62 49.972L36.487 6.978l31.87 42.994-7.332 9.26-8.594-9.26-7.331 9.26-8.594-9.26-7.159 9.26-8.596-9.26-7.686 9.26-8.596-9.26h.151z","fill":"#FFF5D9","stroke":"#000","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M36.412 6.978l-8.383 11.657h16.765L36.412 6.978z","fill":"#565961","stroke":"#000","stroke-width":"2","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M40.762 82.742s-.909 3.31-4.9 3.31c-3.99 0-4.9-3.31-4.9-3.31M45.502 76.49s.644-2.35 3.482-2.35 3.483 2.35 3.483 2.35M20.016 76.49s.644-2.35 3.482-2.35 3.482 2.35 3.482 2.35","stroke":"#000","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    